const Post = ({title, imageURL, date, categories, excerpt, link, author, updateFilter, portrait, author_url}) => {

    const handleCategoryClick = (event) => {
        event.preventDefault()
        updateFilter('blog-filters__category', event.target.getAttribute('data-category'))
    }

    const postImage = () => {
        if (typeof imageURL !== undefined && imageURL !== null) {
            return (typeof link !== 'undefined' && link !== null)
                ? (
                    <a className="image-link" href={link} aria-label="blog-tease-article">
                        <img class="featured-post-image" src={imageURL} alt="blog-tease-article-image"/>
                    </a>
                )
                : <img className="featured-post-image" src={imageURL}/>
        }
    }

    return (
        <article className="tease-post-container">
            <div className="post-image">
                {postImage()}
            </div>
            <div className="post-title h5">
                <a href={link} className="post-wrapper text-link no-underline">{title}</a>
            </div>
            <div className="post-content d-flex align-items-center justify-content-start">
                <img src={portrait} alt={author}/>
                <div className="author-date">
                    <div className="post-author">{author && <span className="post-author">By <a className='text-link underline' href={author_url}>{author}</a> </span>}</div>
                    {date && <div className="post-date">{date}</div>}
                </div>
            </div>
            <a href={link} className="button button-secondary">Full article</a>
        </article>
    )
}

export default Post